<script>
import Config from '@/config';
import AdminMinx from '@/mixins/admin';
import {pageIsFinish} from '@/libs/util';
import {Icon, Tabs, Tab, ContactCard, Cell, List, PullRefresh} from 'vant';
import {getStationRepairRecord, getStationStockRecord, getStationCheckRecord} from '@/api';

export default {
  mixins: [
    AdminMinx
  ],
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [Cell.name]: Cell,
    [ContactCard.name]: ContactCard
  },
  data() {
    return {
      active: 0,

      page: 1,
      listData: null,

      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {
    stationCode() {
      return this.$route.params.stationCode;
    }
  },
  watch: {
    active() {
      this.page = 1;
      this.listData = [];
      this.finished = false;
    },
    stationCode() {
      this.onRefresh();
    }
  },
  methods: {
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();
    },
    getDataApi() {
      if (this.active === 0) {
        return getStationRepairRecord(this.stationCode, {page: this.page, pageSize: Config.pageSize});
      } else if (this.active === 1) {
        return getStationStockRecord(this.stationCode, {page: this.page, pageSize: Config.pageSize});
      } else if (this.active === 2) {
        return getStationCheckRecord(this.stationCode, {page: this.page, pageSize: Config.pageSize});
      }
    },
    loadData() {
      if (this.stationCode) {
        if (this.refreshing) {
          this.listData = [];
          this.refreshing = false;
        }

        this.loading = true;
        this.getDataApi().then(response => {
          this.listData = this.page === 1 ? response.data.body.data : this.listData.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }).finally(() => this.loading = false).catch(() => this.finished = true);
      } else {
        this.page = 1;
        this.listData = [];
      }
    },
    addRecord(id) {
      if (this.active === 0) {
        this.$router.push({name: 'addRepair', params: {stationCode: this.stationCode, repairId: id}});
      } else if (this.active === 1) {
        this.$router.push({name: 'addStockLevel', params: {stationCode: this.stationCode, stockId: id}});
      } else if (this.active === 2) {
        this.$router.push({name: 'addDayCheck', params: {stationCode: this.stationCode, dayCheckId: id}});
      }
    }
  }
}
</script>

<template>
  <div class="record">
    <van-icon name="add" size="48" color="#009251" @click="addRecord(null)"/>
    <van-tabs v-model="active" type="card" color="#009251">
      <van-tab title="维修记录">
        <van-pull-refresh v-if="active === 0" v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
            <van-cell v-for="item in listData" :key="item.id" :title="item.troubleReason" :value="item.recordPeople" size="large" :label="item.createdAt | milliseconds2Datetime" @click="addRecord(item.id)"/>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="库存等级">
        <van-pull-refresh v-if="active === 1" v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
            <van-cell v-for="item in listData" :key="item.id" :title="(item.registerType === 1 ? '领取' : '发放') + item.registerGoodsName" :value="item.recordPeople" size="large" :label="item.createdAt | milliseconds2Datetime" @click="addRecord(item.id)"/>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="站点检查">
        <van-pull-refresh v-if="active === 2" v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
            <van-cell v-for="item in listData" :key="item.id" :title="item.remark" :value="item.recordPeople" size="large" :label="item.createdAt | milliseconds2Datetime" @click="addRecord(item.id)"/>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<style scoped>
.van-icon-add {
  position: fixed;
  right: 16px;
  bottom: 16px;
}

.record {
  padding-top: 16px;
}
</style>